import {
  GET_IDENTIFICATION_TYPES_ERROR,
  GET_IDENTIFICATION_TYPES_SUCCESS,
  GET_IDENTIFICATION_TYPES_SOURCE,
  IDENTIFICATION_SOURCE_DETAILS,
  IDENTIFICATION_SOURCE__DETAILS_SUCCESS,
  IDENTIFICATION_SOURCE_DETAILS_ERROR,
  POST_IDENTIFICATION_INFO,
  POST_IDENTIFICATION_INFO_ERROR,
  POST_IDENTIFICATION_INFO_SUCCESS,
  UPDATE_IDENTIFICATION_INFO,
  UPDATE_IDENTIFICATION_INFO_ERROR,
  UPDATE_IDENTIFICATION_INFO_SUCCESS,
} from './identificationVerificationConstants';

export const getIdentificationTypes = (payload) => ({
  type: GET_IDENTIFICATION_TYPES_SOURCE,
  payload,
});

export const getIdentificationTypesSuccess = (payload) => ({
  type: GET_IDENTIFICATION_TYPES_SUCCESS,
  payload,
});
export const getIdentificationTypesError = (payload) => ({
  type: GET_IDENTIFICATION_TYPES_ERROR,
  payload,
});

export const setIdentificationInfoDetails = (payload) => ({
  type: IDENTIFICATION_SOURCE__DETAILS_SUCCESS,
  payload,
});

export const getIdentificationInfoDetails = (payload) => ({
  type: IDENTIFICATION_SOURCE_DETAILS,
  payload,
});

export const getIdentificationInfoError = (payload) => ({
  type: IDENTIFICATION_SOURCE_DETAILS_ERROR,
  payload,
});

export const identificationInfoData = (payload) => ({
  type: POST_IDENTIFICATION_INFO,
  payload,
});

export const identificationInfoDataSuccess = (payload) => ({
  type: POST_IDENTIFICATION_INFO_SUCCESS,
  payload,
});

export const identificationInfoDataError = (payload) => ({
  type: POST_IDENTIFICATION_INFO_ERROR,
  payload,
});

export const updateidentificationInfoData = (payload) => ({
  type: UPDATE_IDENTIFICATION_INFO,
  payload,
});

export const updateIdentificationInfoDataSuccess = (payload) => ({
  type: UPDATE_IDENTIFICATION_INFO_SUCCESS,
  payload,
});

export const updateIdentificationInfoDataError = (payload) => ({
  type: UPDATE_IDENTIFICATION_INFO_ERROR,
  payload,
});
